import { useCallback, useEffect, useRef, useState } from 'react';

// 管理 Transfer In popup 顶部提示和自动关闭 timer。
export default function useTransferInAlert() {
  const [isMyAlert, setIsMyAlert] = useState(0);
  const myAlertTimerRef = useRef(null);

  const closeMyAlert = useCallback(() => {
    setIsMyAlert(0);
  }, []);

  const showMyAlert = useCallback(
    (value) => {
      if (myAlertTimerRef.current) {
        clearTimeout(myAlertTimerRef.current);
      }
      setIsMyAlert(value);
      myAlertTimerRef.current = setTimeout(closeMyAlert, 1500);
    },
    [closeMyAlert]
  );

  // 组件卸载时清理 alert timer。
  useEffect(() => {
    return () => {
      if (myAlertTimerRef.current) {
        clearTimeout(myAlertTimerRef.current);
      }
    };
  }, []);

  return {
    closeMyAlert,
    isMyAlert,
    showMyAlert,
  };
}
